import React from "react";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import { useNavigate } from "react-router-dom";
import image1 from "../../images/1.png";
import image2 from "../../images/2.png";
import image3 from "../../images/3.png";
import image4 from "../../images/4.png";
import image5 from "../../images/5.png";
import image6 from "../../images/6.png";
import image7 from "../../images/7.png";
import image8 from "../../images/8.png";
import "./Services.css";

interface Service {
  title: string;
  img: string;
  link: string;
}

export const services: Service[] = [
  { title: "offshore medicine", img: image1, link: "/offshore-medicine" },
  { title: "diving medicine", img: image2, link: "/diving-medicine" },
  { title: "maritime medicine", img: image3, link: "/maritime-medicine" },
  { title: "occupational health", img: image4, link: "/occupational-health" },
  { title: "health surveillance", img: image5, link: "/health-surveillance" },
  { title: "onsite assessment", img: image6, link: "/onsite-assessment" },
  { title: "hbot", img: image7, link: "/hbot" },
  { title: "training center", img: image8, link: "/training-center" },
];

const Services: React.FC = () => {
  const navigate = useNavigate();

  const handleCardClick = (link: string) => {
    if (link !== "#") {
      navigate(link);
    }
  };

  return (
    <section className="services-section">
      <div className="services">
        <div className="card-grid">
          {services.map((service, index) => (
            <div
              className="service-card"
              key={index}
              onClick={() => handleCardClick(service.link)}
              style={{ cursor: service.link !== "#" ? "pointer" : "default" }}
            >
              <CardMedia
                component="img"
                image={service.img}
                alt={service.title}
              />
              <div className="service-title">{service.title}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
